/* No purchase-control moves or late style injection. */
if (!customElements.get('pg-gallery-dots')) {
  customElements.define('pg-gallery-dots', class extends HTMLElement {
    connectedCallback() {
      this.viewer = this.closest('slider-component');
      this.slider = this.viewer?.querySelector('[id^="Slider-Gallery-"]');
      this.gallery = this.closest('media-gallery');
      if (!this.slider) return;
      this.mobile = matchMedia('(max-width: 749px)');
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
      };
      this.onClick = event => {
        const button = event.target.closest('button[data-pg-media-id]');
        if (!button || !this.contains(button)) return;
        const slide = Array.from(this.slider.children).find(node => node.dataset.mediaId === button.dataset.pgMediaId);
        if (!slide) return;
        if (typeof this.gallery?.setActiveMedia === 'function') this.gallery.setActiveMedia(button.dataset.pgMediaId, false);
        else this.slider.scrollTo({left: this.slider.scrollLeft + slide.getBoundingClientRect().left - this.slider.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.addEventListener('click', this.onClick);
      this.slider.addEventListener('scroll', this.schedule, {passive: true});
      this.viewer.addEventListener('slideChanged', this.schedule);
      this.mobile.addEventListener('change', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.slider, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden']});
      this.resizer = new ResizeObserver(this.schedule);
      this.resizer.observe(this.slider);
      this.refresh();
    }
    refresh() {
      if (!this.mobile.matches) return;
      const slides = Array.from(this.slider.children).filter(node => node.dataset.mediaId && getComputedStyle(node).display !== 'none');
      const existing = new Map(Array.from(this.children).map(button => [button.dataset.pgMediaId, button]));
      const ids = slides.map(slide => slide.dataset.mediaId);
      if (ids.join('|') !== Array.from(this.children).map(button => button.dataset.pgMediaId).join('|')) {
        this.replaceChildren(...slides.map((slide, index) => {
          const button = existing.get(slide.dataset.mediaId) || document.createElement('button');
          button.type = 'button'; button.dataset.pgMediaId = slide.dataset.mediaId;
          button.setAttribute('aria-controls', this.slider.id);
          button.setAttribute('aria-label', 'View product image ' + (index + 1));
          return button;
        }));
      }
      this.hidden = slides.length < 2;
      if (!slides.length) return;
      const edge = this.slider.getBoundingClientRect().left;
      const active = slides.reduce((best, slide) => Math.abs(slide.getBoundingClientRect().left - edge) < Math.abs(best.getBoundingClientRect().left - edge) ? slide : best);
      Array.from(this.children).forEach(button => button.setAttribute('aria-current', String(button.dataset.pgMediaId === active.dataset.mediaId)));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.frame = 0;
      this.observer?.disconnect(); this.resizer?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.slider?.removeEventListener('scroll', this.schedule);
      this.viewer?.removeEventListener('slideChanged', this.schedule);
      this.mobile?.removeEventListener('change', this.schedule);
    }
  });
}
if (!customElements.get('pg-product-videos')) {
  customElements.define('pg-product-videos', class extends HTMLElement {
    connectedCallback() {
      this.mobile = matchMedia('(max-width: 749px)');
      this.onChange = () => {
        if (getComputedStyle(this).display !== 'none') return;
        this.querySelectorAll('video').forEach(video => video.pause());
        this.querySelectorAll('iframe').forEach(frame => {
          let origin;
          try { origin = new URL(frame.src).origin; } catch { return; }
          if (frame.classList.contains('js-youtube')) frame.contentWindow?.postMessage(JSON.stringify({event: 'command', func: 'pauseVideo', args: ''}), origin);
          if (frame.classList.contains('js-vimeo')) frame.contentWindow?.postMessage(JSON.stringify({method: 'pause'}), origin);
        });
      };
      this.mobile.addEventListener('change', this.onChange);
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
      this.mobile?.removeEventListener('change', this.onChange);
    }
  });
}
